export default __webpack_public_path__ + "static/media/img1.445d7666.png";